export default __webpack_public_path__ + "alberta-status-star.25a0005865456f497503.svg";